import { CustomTable, StackedBarChart, TitleWithRightAction } from "components";
import { useMemo, useState } from "react";
import { formatNumber } from "utils/formatNumber";

const ShareholderType = ({ data = {} } = {}) => {
  const [isTable, setIsTable] = useState(false);

  const headCells = [
    {
      id: "group",
      label: <span className='text-sm text-[#5F737F]'>Type</span>,
    },
    {
      id: "no_of_shareholders",
      label: <span className='text-sm text-[#5F737F]'>No. of Investors</span>,
      numeric: true,
    },
    {
      id: "ownership_percentage",
      label: <span className='text-sm text-[#5F737F]'>Shares Ownership</span>,
      numeric: true,
    },
  ];

  const bodyCells = useMemo(() => {
    const dataArr = data?.distribution?.map((el) => ({
      ...el,
      id: el?.group,
      group: <span className='text-sm text-[#5F737F]'>{el?.group}</span>,
      ownership_percentage: `${el?.ownership_percentage?.toFixed(2)}%`,
    }));

    // Render Footer
    if (dataArr?.length) {
      dataArr.push({
        id: "Total",
        group: <span className='text-sm text-[#5F737F]'>Total</span>,
        no_of_shareholders: data?.total,
        ownership_percentage: "100.00%",
        isFooter: true,
      });
    }

    return dataArr;
  }, [data]);

  const chartData = useMemo(
    () =>
      data?.distribution?.map((el) => ({
        label: el?.group,
        value: el?.no_of_shareholders ?? 0,
      })),
    [data],
  );

  return (
    <div className='section map-section h-full'>
      <TitleWithRightAction title='Shareholders Type'>
        <span
          onClick={() => setIsTable((prev) => !prev)}
          className='cursor-pointer text-blue-700 font-bold hover:text-blue-500 text-xs'
        >
          {isTable ? "View as Chart" : "View as Table"}
        </span>
      </TitleWithRightAction>

      {isTable ? (
        <div className='mt-4'>
          <CustomTable
            id='shareholder-type-table'
            headCells={headCells}
            bodyCells={bodyCells}
            showPagination={false}
            borderless
            sx={{
              ".MuiTableCell-root.MuiTableCell-head": {
                px: "0px !important",
                pt: "0px !important",
                pb: "8px !important",
              },
              ".MuiTableCell-root.MuiTableCell-body": {
                px: "0px !important",
                py: "4px !important",
                borderBottom: "none",
              },
              ".MuiTableHead-root": {
                background: "transparent",
              },
            }}
          />
        </div>
      ) : (
        <>
          <div className='flex gap-1 mt-4 mb-2 text-sm'>
            <span className='text-[#5F737F]'>Total shareholders:</span>
            <span>{formatNumber.toAmount(data?.total ?? 0)}</span>
          </div>

          <StackedBarChart data={chartData} />
        </>
      )}
    </div>
  );
};

export default ShareholderType;
